import cx from 'classnames';

import Typography from '../Typography';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';

interface Props {
  title: string;
  subtitle?: string;
  titleSize: Size;
  subtitleSize: Size;
  titleColor?: string;
  subtitleColor?: string;
  fontFamily: string;
  textClassName?: string;
  showSubtitle?: boolean;
}

const Titles = ({
  title,
  subtitle,
  titleSize,
  fontFamily,
  subtitleSize,
  titleColor,
  subtitleColor,
  textClassName,
  showSubtitle = true,
}: Props) => {
  return (
    <>
      <Typography
        as="h2"
        size={titleSize}
        fontFamily={fontFamily}
        weight="bold"
        color={titleColor}
        className={cx('line-clamp-4 break-words', textClassName)}
      >
        {title}
      </Typography>
      {showSubtitle && (
        <Typography
          as="p"
          size={subtitleSize}
          fontFamily={fontFamily}
          color={subtitleColor}
          className={cx('line-clamp-2 break-words', textClassName)}
        >
          {subtitle}
        </Typography>
      )}
    </>
  );
};

export default Titles;
